import Button from '@components/button/Button';

import { TabErrorProps } from '../../types/leadActivity';

const TabError = ({
  handleRefetch,
  message = 'Failed to load timeline data'
}: TabErrorProps) => (
  <div className="flex flex-col items-center justify-center bg-white p-6">
    <div className="mb-4 text-red-500">{message}</div>
    <Button
      handleClick={handleRefetch}
      label="Retry"
      variant="primary"
      size="medium"
    />
  </div>
);

export default TabError;
